module.exports = __webpack_public_path__ + "static/saudiarabia-e73b3aa7e3ebc53fa8e76c26dff0c94a.png";